import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import {
  Message,
  Attachment as UpdateAttachment,
} from '../@types/UpdateQuotation'

type UpdateQuotation = {
  quotationId?: string
  message?: Message
  attachments?: UpdateAttachments[]
}

type UpdateAttachments = {
  id: number
} & UpdateAttachment

type Store = {
  quotationUpdate: UpdateQuotation | null
  setQuotationUpdate: (value: UpdateQuotation) => void
  updateQuotationMessage: (value: UpdateQuotation) => void
  deleteUpdateAttachments: (id: number) => void
  resetQuotationMessage: () => void
}

export const useQuotationMessageUpdateStore = create<Store>()(
  devtools(
    (set) => ({
      quotationUpdate: { attachments: [] },
      setQuotationUpdate: (quotationUpdate) => set({ quotationUpdate }),
      updateQuotationMessage: (updatedValues) =>
        set((state) => ({
          quotationUpdate: {
            ...state.quotationUpdate,
            ...updatedValues,
          },
        })),
      deleteUpdateAttachments: (id) =>
        set((state) => {
          const newData = state.quotationUpdate?.attachments?.filter(
            (file) => file.id !== id,
          )

          return {
            quotationUpdate: { ...state.quotationUpdate, attachments: newData },
          }
        }),
      resetQuotationMessage: () =>
        set({
          quotationUpdate: { attachments: [], message: { messageText: '' } },
        }),
    }),

    { name: 'QuotationMessageUpdateStore' },
  ),
)
